module.exports = __webpack_public_path__ + "img/cooling_assist_setting.5950d82b.png";